'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _ClientData = require('conversations-schema/records/ClientData');

var _ClientData2 = _interopRequireDefault(_ClientData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionTypeToKey = function actionTypeToKey(type) {
  return type.toLowerCase().replace(/_\w/g, function (word) {
    return word[1].toUpperCase();
  });
};

var initialState = (0, _ClientData2.default)();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.CONVERSATIONS_CLIENT_READY, function (state) {
  return state.merge({ isPubNubClientConnected: true });
}), _defineProperty(_handleActions, ActionTypes.APP_IN_FOREGROUND, function (state) {
  return state.set('isInForeground', true);
}), _defineProperty(_handleActions, ActionTypes.APP_IN_BACKGROUND, function (state) {
  return state.set('isInForeground', false);
}), _defineProperty(_handleActions, ActionTypes.CONVERSATIONS_CLIENT_READY, function (state, action) {
  var key = actionTypeToKey(action.type);
  return state.updateIn(['timestamps', key], function (timestamp) {
    return timestamp || Date.now();
  });
}), _defineProperty(_handleActions, ActionTypes.NETWORK_ONLINE, function (state) {
  return state.set('isPubNubClientConnected', true);
}), _defineProperty(_handleActions, ActionTypes.NETWORK_OFFLINE, function (state) {
  return state.set('isPubNubClientConnected', false);
}), _handleActions), initialState);
module.exports = exports['default'];